import { useEffect, useState } from 'react';
import { lockOrientation, addOrientationChangeListener, isPortrait } from '@/lib/orientation-lock';
import { isMobileDevice } from '@/lib/device-detection';

/**
 * React hook for managing device orientation lock
 * Only works on mobile devices
 */
export const useOrientationLock = (enabled: boolean = true) => {
  const [isPortraitMode, setIsPortraitMode] = useState(isPortrait());
  const isMobile = isMobileDevice();

  useEffect(() => {
    // Only attempt orientation lock on mobile devices when enabled
    if (!isMobile || !enabled) {
      return;
    }

    // Attempt to lock orientation on mount
    lockOrientation();

    // Listen for orientation changes
    const removeListener = addOrientationChangeListener((portrait) => {
      setIsPortraitMode(portrait);
      
      // Re-attempt to lock if not in portrait
      if (!portrait) {
        setTimeout(() => {
          lockOrientation();
        }, 100);
      }
    });

    // Initial check
    setIsPortraitMode(isPortrait());

    return removeListener;
  }, [isMobile]);

  return {
    isPortraitMode,
    lockOrientation,
    isMobile,
  };
};
